import { Label } from "@centricsoftware/design-system";
import clsx from "clsx";
import { FlexRowCenter } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import panelCss from "./FormAttributesPanel.module.css";
import { useFormDefinitionStore } from "./FormDefinitionStore";

const DASH = "-";

const FormAttributeDetails: FC = observer(() => {
	const { activeField, loc: { attributeResource, resource } } = useFormDefinitionStore();
	const formatConfigurableAttributeText = attributeResource("ConfigurableAttribute", "Format");
	const localeNameText = resource("LocaleName");
	const notesConfigurableAttributeText = attributeResource("ConfigurableAttribute", "Notes");
	const ownerText = resource("Owner");
	const valueTypeConfigurableAttributeText = attributeResource("ConfigurableAttribute", "ValueType");

	return (
		<>
			<FlexRowCenter className={clsx(panelCss.panelRow, panelCss.panelRowBottomBorder)}>
				<Label textRes={{ res: "ConfigurableAttribute.Name" }} />
				<span>{activeField.attributeId}</span>
			</FlexRowCenter>
			<FlexRowCenter className={clsx(panelCss.panelRow, panelCss.panelRowBottomBorder)}>
				<Label text={localeNameText} />
				<span>{activeField.label}</span>
			</FlexRowCenter>
			<FlexRowCenter className={clsx(panelCss.panelRow, panelCss.panelRowBottomBorder)}>
				<Label text={valueTypeConfigurableAttributeText} />
				<span>{activeField.valueType}</span>
			</FlexRowCenter>
			<FlexRowCenter className={clsx(panelCss.panelRow, panelCss.panelRowBottomBorder)}>
				<Label text={formatConfigurableAttributeText} />
				<span>{activeField.format || DASH}</span>
			</FlexRowCenter>
			<FlexRowCenter className={clsx(panelCss.panelRow, panelCss.panelRowBottomBorder)}>
				<Label text={notesConfigurableAttributeText} />
				<span>{activeField.notes || DASH}</span>
			</FlexRowCenter>
			<FlexRowCenter className={panelCss.panelRow}>
				<Label text={ownerText} />
				<span>{activeField.reflectionAttributeOwner || DASH}</span>
			</FlexRowCenter>
		</>
	);
});

export default FormAttributeDetails;
